import React,{useEffect,useState} from 'react';
import Logo from '../../components/common/Logo';
import RegisterForm from '../../components/Auth/RegisterForm';
import {useNavigate,useLocation, useParams} from 'react-router-dom';
import queryString from 'query-string';

const Register = () => {
    const navigate = useNavigate();
    const[utmParams,setUtmParams]=useState({})
    const location = useLocation();
    // const useparams = useParams();

       
    // useEffect(() => {
    //     window.gtag("config", "UA-185641939-1", {
    //     page_title: location.pathname,
    //     page_path:location.pathname,
    //     })
    //   }, [location]);
      
    //     useEffect(() => {
    //       window.gtag("config", "GTM-WD9H59N", {
    //       page_title: location.pathname,
    //       page_path:location.pathname,
    //       })
    //   }, [location]);

    useEffect(() => {
        if(sessionStorage.getItem('userDetail')){
            navigate('/dashboard');
        }

        const qParams = queryString.parse(location.search);

        // console.log('qParams..',qParams)

        if (qParams !== null) {
            const{channel_name,current_channel_name,source,lead_source,campaign_name,utm_adgroup,utm_campaign,utm_medium,utm_source,utm_term} =qParams
            let utmObj={
                channel_name:channel_name?channel_name:'',
                current_channel_name:current_channel_name?current_channel_name:'',
                source:source?source:'',
                lead_source:lead_source?lead_source:'',
                campaign_name:campaign_name?campaign_name:'',
                utm_adgroup:utm_adgroup?utm_adgroup:'',
                utm_campaign:utm_campaign?utm_campaign:'',
                utm_medium:utm_medium?utm_medium:'',
                utm_source:utm_source?utm_source:'',
                utm_term:utm_term?utm_term:'',
            }
            
            setUtmParams(utmObj)
        }

    },[]);


    return(
        <section className="py-4 register-page">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 text-center">
                    <Logo alt="Logo"/>
                </div>
            </div>
            <div className="row justify-content-center">
                
                <div className="col-lg-10">
                    
                    <div className="register-box">
                        <div className="page-head">
                            <h3 className='fs-4 text-center text-primary fw-bold'>Registrations 2023-24 session</h3>
                        </div>

                        {/* <div className="row mt-4">
                        <div className="col-lg-8 mx-auto">
                            <h5 className='text-center fs-5 text-dark'>Registrations for the 2023-24 session are now closed.<br></br> Visit 
                            <a className='fs-5 ms-2' href="https://www.allenoverseas.com/ccp2024" title='ALLEN Overseas registration panel'><b>https://www.allenoverseas.com/ccp2024</b></a> for registration on the 2024-25 session. </h5>

                            </div>
                        </div> */}

                        <RegisterForm utmParams={utmParams}/>
                    </div>
                </div>
                
            </div>
        </div>
    </section>
    );
}


export default Register;